import React, { useEffect } from "react";
import { FaUser } from "react-icons/fa";
import { MdAccountBalance } from "react-icons/md";
import { Button, Form, FormGroup, Label, Spinner } from "reactstrap";
import EasypaisaLogo from "assets/img/Easypaisa2.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchEasyPaisaDetails } from "store/actions/RequestActions";
import ImageUploadInput from "components/shared/ImageUploadInput";

const EasypaisaPayment = ({
  card = true,
  file,
  setFile,
  handleFileChange,
  loading,
  disabled = false,
  handleSubmit,
}) => {
  const dispatch = useDispatch();
  const { easyPaisaDetails } = useSelector((state) => state.requests);

  useEffect(() => {
    dispatch(fetchEasyPaisaDetails());
  }, [dispatch]);
  return (
    <div className={`${card && "rounded login bg-secondary shadow"} border-0`}>
      <div className={`${card && "card-body px-lg-5 py-lg-4"}`}>
        {card && (
          <div className="d-flex flex-column justify-content-center align-items-center">
            <img src={EasypaisaLogo} alt="easypaisa" className="mb-3 w-50" />
            <div className="d-flex flex-column justify-content-center align-items-center">
              <p className="typography text-center">
                Pay to Easypaisa account using the following details and attach
                a screenshot for confirmation.
              </p>
            </div>
          </div>
        )}
        <Label className="form_label text-center mb-2">Payment Details</Label>
        <div className="border rounded p-2 mb-2 bg-secondary">
          <div className="d-flex align-items-center">
            <FaUser />
            <div className="ml-3">
              <p className="typography mb-0">Account Holder Name</p>
              <h3>
                {" "}
                {easyPaisaDetails?.name
                  ? easyPaisaDetails?.name
                  : "Admin Account Name"}
              </h3>
            </div>
          </div>
          <div className="d-flex align-items-center">
            <MdAccountBalance />
            <div className="ml-3">
              <p className="typography mb-0">Easypaisa Account Number</p>
              <h3>
                {" "}
                {easyPaisaDetails?.phoneNo
                  ? easyPaisaDetails?.phoneNo
                  : "Admin Account Number"}
              </h3>
            </div>
          </div>
        </div>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label>Payment Screenshot</Label>
            <ImageUploadInput
              image={file}
              onImageChange={handleFileChange}
              onRemoveImage={() => setFile(null)}
              fullPreview
              height="160px"
            />
          </FormGroup>
          <Button
            className="w-100 login__btn"
            type="submit"
            disabled={!file || disabled || loading}
          >
            {loading ? <Spinner size="sm" /> : "Submit"}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default EasypaisaPayment;
